import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

// Apply persisted theme BEFORE first paint to avoid a flash of the wrong theme.
try {
  const stored = localStorage.getItem("mo_theme");
  document.documentElement.setAttribute("data-theme", stored === "light" ? "light" : "dark");
} catch { /* localStorage may be unavailable */ }

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
